import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';

import { TextField, Switch } from '@mui/material';
import { ReactComponent as Volume } from "../../../assets/images/Volume.svg";
import { ReactComponent as Dropdown } from '../../../assets/images/dropdown-arrow.svg';
import { getSoundSetting } from '../../../store/features/getSoundSetting'
import { coUserUpdateSound } from '../../../store/features/coUserUpdateSound';
import styled from '@emotion/styled';

function Notification() {
  const [sound, setSound] = useState(null);
  const [repeat, setRepeat] = useState(null);

  const [isProcessing, setIsProcessing] = useState(false);
  const [isRepeatProcessing, setIsRepeatProcessing] = useState(false);

  const userData = useSelector((state) => state.loginToken);
  const dispatch = useDispatch();

  useEffect(() => {
    getSound();
  }, []);

  const getSound = async () => {
    const listCoUserList = dispatch(
      getSoundSetting({
        id: userData?.response?.user?._id,
      }),
    );
    listCoUserList
      .then(async (data) => {
        if (data?.payload?.status === 200) {
          const settings = data.payload?.settings;
          setSound(settings?.enableNotifications || false);
          setRepeat(settings?.repeatSound || false);
        }
      })
      .catch(async (error) => {
      });
  };

  const handleSoundChange = async (event) => {
    if (isProcessing) return;

    const isChecked = event.target.checked;
    setSound(isChecked);
    setIsProcessing(true);

    const CoUserUpdates = dispatch(
      coUserUpdateSound({
        id: userData?.response?.user?._id,
        requestHeaders: { enableNotifications: isChecked, repeatSound: repeat },
      }),
    );
    CoUserUpdates
      .then(async (data) => {
        if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message);
          // Inform the app about updated sound settings
          window.dispatchEvent(new CustomEvent('sound-settings-updated', { detail: { enableNotifications: isChecked } }));
        } else {
          toast.error(data?.payload?.message);
        }
      })
      .catch(async (error) => {
        toast.error(error);
      })

    setTimeout(() => {
      setIsProcessing(false);
    }, 4000);
  };

  const handleRepeatChange = async (event) => {
    if (isRepeatProcessing) return;

    const isChecked = event.target.checked;
    setRepeat(isChecked);
    setIsRepeatProcessing(true);

    const CoUserUpdates = dispatch(
      coUserUpdateSound({
        id: userData?.response?.user?._id,
        requestHeaders: { enableNotifications: sound, repeatSound: isChecked },
      }),
    );
    CoUserUpdates
      .then(async (data) => {
        if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message);
          // Also notify app if repeat change should reflect (optional for future use)
          window.dispatchEvent(new CustomEvent('sound-settings-updated', { detail: { repeatSound: isChecked } }));
        } else {
          toast.error(data?.payload?.message);
        }
      })
      .catch(async (error) => {
        toast.error(error);
      })

    setTimeout(() => {
      setIsRepeatProcessing(false); // Re-enable the toggle after 2 seconds
    }, 4000);
  };
  const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 36,
    height: 20,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,

      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#148DFD', // MUI Select Sound blue
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 16,
      height: 16,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));
  return (
    <div className="notifications-wrapper">


      <div className="TicketManagment-Container001">

        <p style={{ lineHeight: '24px' }} className="Ticket-text">Notifications</p>

      </div>
      <div className="notifications-main-container">

        {/* <div className="Personal-Information-Main-Container"> */}

        {/* <div className="Personal-Information"> */}
        <div className='Notification-Main-Container'>
          <div>
            <div className='Personal-Info-Text-Container'>
              <p className="Personal-Info-Text">Notifications</p>
              <p className="notification-description">Review and manage your notification.</p>
            </div>

          </div>
          <div>
            <div style={{ height: '96px' }} className='Notification-Sound'>
              <div className='Notification-Sound-Row-One'>
                <Volume />
                <FormControlLabel
                  control={<IOSSwitch checked={sound} sx={{ m: 1, mr: 0 }} onChange={handleSoundChange} disabled={isProcessing} />}
                />
                <span className="Notification-Sound-Text">
                  Notification sound
                </span>
              </div>

              <div className='Notification-Sounds-Row-Text' style={{ marginLeft: '74px' }}>
                <input
                  type="checkbox"
                  id='nameCheckbox'
                  name='nameCheckbox'
                  className="custom-checkbox"
                  checked={repeat}
                  onChange={handleRepeatChange}
                  disabled={isRepeatProcessing}
                />
                <label htmlFor="nameCheckbox">
                  <span className='notification-checkbox'>Repeat </span>
                  <span className='notification-checkbox-underline'>New Notification</span>
                  <span className='notification-checkbox-nm'> sound until message is read</span>
                </label>
              </div>

            </div>

            <div className='Notification-Sounds'>
              <p className="Notification-Sounds-Text">Notify me about…</p>

              <div className='Notification-Sounds-Row'>
                <div className='Notification-Sounds-Row-Text'>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                  />
                  <label htmlFor="nameCheckbox1">
                    <span className='notification-checkbox'>New messages</span>
                    <span className='notification-checkbox-link'> (test)</span>
                  </label>
                </div>

                <Autocomplete
                  disableClearable
                  value="Select Sound"
                  options={[]}
                  defaultValue=''
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      width: '216px',
                      height: '40px',
                      minHeight: '40px',
                      cursor: 'pointer',
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      fontSize: '14px',
                      color: '#405261 !important',
                      fontWeight: '400',
                      fontFamily: 'Inter',
                      cursor: 'pointer',
                    },
                    '& input': {
                      color: '#405261 !important',
                    },
                  }}

                  size="small"
                  popupIcon={<Dropdown />}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      InputProps={{
                        ...params.InputProps,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  )}
                />
              </div>
              <div className='Notification-Sounds-Row'>
                <div className='Notification-Sounds-Row-Text'>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                  />
                  <label htmlFor="nameCheckbox1">
                    <span className='notification-checkbox'>Incoming Chats</span>
                    <span className='notification-checkbox-link'> (test)</span>
                  </label>
                </div>

                <Autocomplete
                  disableClearable
                  value="Select Sound"
                  options={[]}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      width: '216px',
                      height: '40px',
                      minHeight: '40px',
                      cursor: 'pointer',
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      fontSize: '14px',
                      color: '#405261 !important',
                      fontWeight: '400',
                      fontFamily: 'Inter',
                      cursor: 'pointer',
                    },
                    '& input': {
                      color: '#405261 !important',
                    },
                  }}
                  size="small"
                  popupIcon={<Dropdown />}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      InputProps={{
                        ...params.InputProps,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  )}
                />
              </div>
              <div className='Notification-Sounds-Row'>
                <div className='Notification-Sounds-Row-Text'>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                  />
                  <label htmlFor="nameCheckbox1">
                    <span className='notification-checkbox'>New tickets to handle</span>
                    <span className='notification-checkbox-link'> (test)</span>
                  </label>
                </div>

                <Autocomplete
                  disableClearable
                  value="Select Sound"
                  options={[]}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      width: '216px',
                      height: '40px',
                      minHeight: '40px',
                      cursor: 'pointer',
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      fontSize: '14px',
                      color: '#405261 !important',
                      fontWeight: '400',
                      fontFamily: 'Inter',
                      cursor: 'pointer',
                    },
                    '& input': {
                      color: '#405261 !important',
                    },
                  }}
                  size="small"
                  popupIcon={<Dropdown />}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      InputProps={{
                        ...params.InputProps,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  )}
                />
              </div>

              <div className='Notification-Sounds-Row'>
                <div className='Notification-Sounds-Row-Text'>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                  />
                  <label htmlFor="nameCheckbox1">
                    <span className='notification-checkbox'>Visitor is in the queue</span>
                    <span className='notification-checkbox-link'> (test)</span>
                  </label>
                </div>

                <Autocomplete
                  disableClearable
                  value="Select Sound"
                  options={[]}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      width: '216px',
                      height: '40px',
                      minHeight: '40px',
                      cursor: 'pointer',
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      fontSize: '14px',
                      color: '#405261 !important',
                      fontWeight: '400',
                      fontFamily: 'Inter',
                      cursor: 'pointer',
                    },
                    '& input': {
                      color: '#405261 !important',
                    },
                  }}
                  size="small"
                  popupIcon={<Dropdown />}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      InputProps={{
                        ...params.InputProps,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  )}
                />
              </div>
              <div className='Notification-Sounds-Row'>
                <div className='Notification-Sounds-Row-Text'>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                  />
                  <label htmlFor="nameCheckbox1">
                    <span className='notification-checkbox'>New Visitors</span>
                    <span className='notification-checkbox-link'> (test)</span>
                  </label>
                </div>

                <Autocomplete
                  disableClearable
                  value="Select Sound"
                  options={[]}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      width: '216px',
                      height: '40px',
                      minHeight: '40px',
                      cursor: 'pointer',
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      fontSize: '14px',
                      color: '#405261 !important',
                      fontWeight: '400',
                      fontFamily: 'Inter',
                      cursor: 'pointer',
                    },
                    '& input': {
                      color: '#405261 !important',
                    },
                  }}
                  size="small"
                  popupIcon={<Dropdown />}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      InputProps={{
                        ...params.InputProps,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  )}
                />
              </div>
              <div className='Notification-Sounds-Row'>
                <div className='Notification-Sounds-Row-Text'>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                  />
                  <label htmlFor="nameCheckbox1">
                    <span className='notification-checkbox'>Returning visitors</span>
                    <span className='notification-checkbox-link'> (test)</span>
                  </label>
                </div>

                <Autocomplete
                  disableClearable
                  value="Select Sound"
                  options={[]}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      width: '216px',
                      height: '40px',
                      minHeight: '40px',
                      cursor: 'pointer',
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      fontSize: '14px',
                      color: '#405261 !important',
                      fontWeight: '400',
                      fontFamily: 'Inter',
                      cursor: 'pointer',
                    },
                    '& input': {
                      color: '#405261 !important',
                    },
                  }}
                  size="small"
                  popupIcon={<Dropdown />}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      InputProps={{
                        ...params.InputProps,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  )}
                />
              </div>

            </div>

            <button className="Personal-Information-Save-Button" type="button">Save Changes</button>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
    </div>
  )
}

export default Notification;